import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut, sendPasswordResetEmail } from 'firebase/auth';
import { app } from '../firebase';
import { useUser } from '../contexts/UserContext';

const auth = getAuth(app);

const Auth = () => {
  const { user } = useUser();
  console.log('[Auth] Rendered. user:', user);
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [validationError, setValidationError] = useState('');


  function validate() {
    if (!email) return 'Email is required.';
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) return 'Enter a valid email address.';
    if (!password) return 'Password is required.';
    if (password.length < 6) return 'Password must be at least 6 characters.';
    return '';
  }

  const handleSignup = async (e) => {
    e.preventDefault();
    setValidationError('');
    setLoading(true);
    setError('');
    const vErr = validate();
    if (vErr) {
      setValidationError(vErr);
      setLoading(false);
      return;
    }
    try {
      await createUserWithEmailAndPassword(auth, email, password);
      navigate('/profile'); // Redirect to profile after signup
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setValidationError('');
    setLoading(true);
    setError('');
    const vErr = validate();
    if (vErr) {
      setValidationError(vErr);
      setLoading(false);
      return;
    }
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate('/profile'); // Redirect to profile after login
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  };

  const handleLogout = async () => {
    setLoading(true);
    setError('');
    try {
      await signOut(auth);
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  };

  console.log('[Auth] About to render. user:', user);
  return (
    <div style={{ minHeight: '100vh', position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 60%, #67c6ff 100%)' }}>
      
      <div className="max-w-md w-full p-12 border border-gray-100 rounded-2xl shadow-2xl bg-white" style={{ boxShadow: '0 8px 32px 0 rgba(30,60,114,0.18)', zIndex: 1, position: 'relative' }}>
        <h2 className="text-3xl font-extrabold text-center mb-10" style={{
  fontSize: 44,
  letterSpacing: 2,
  fontFamily: 'Poppins, Montserrat, Segoe UI, Arial, sans-serif',
  color: '#fff',
  textShadow: '0 4px 24px rgba(30,60,114,0.22)',
  fontWeight: 900,
}}>Hey Candidate</h2>
        {user ? (
          <>
            <p className="mb-4 text-center">Logged in as: <b>{user.email}</b></p>
            <div className="flex justify-end mt-6">
              <button
                onClick={handleLogout}
                disabled={loading}
                className="bg-orange-700 text-white rounded-md px-6 py-2 font-bold text-lg shadow hover:bg-orange-800 transition disabled:opacity-60"
              >
                {loading ? 'Logging out...' : 'Logout'}
              </button>
            </div>
          </>
        ) : (
          <>
            
            <form className="space-y-7" onSubmit={e => e.preventDefault()}>
              <div>
                <input
                  type="email"
                  placeholder="Email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  required
                  className="w-full px-4 py-3 text-lg border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                />
              </div>
              <div>
                <input
                  type="password"
                  className="w-full px-6 py-4 rounded-xl border border-gray-200 mt-4 focus:outline-none focus:ring-2 focus:ring-blue-400"
                  placeholder="Password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  autoComplete="current-password"
                  style={{ fontSize: 20 }}
                />
                <div style={{ textAlign: 'right', marginTop: 6 }}>
                  <button
                    type="button"
                    onClick={async () => {
                      const emailPrompt = email || window.prompt('Enter your email to reset your password:');
                      if (!emailPrompt) return;
                      try {
                        await sendPasswordResetEmail(auth, emailPrompt);
                        alert('Password reset email sent! Please check your inbox.');
                      } catch (err) {
                        alert(err.message);
                      }
                    }}
                    style={{ background: 'none', border: 'none', color: '#1e3c72', textDecoration: 'underline', cursor: 'pointer', fontSize: 16, fontWeight: 600, padding: 0 }}
                  >
                    Forgot password?
                  </button>
                </div>
              </div>
              {validationError && <p className="text-red-600 text-sm text-center">{validationError}</p>}
              <div className="flex justify-center mt-4 mb-4">
                <button
                  type="button"
                  onClick={handleLogin}
                  disabled={loading}
                  className="bg-blue-700 text-white px-8 py-4 rounded-xl font-bold text-xl shadow-md hover:bg-blue-800 hover:shadow-lg transition-all duration-200 transform hover:scale-105 disabled:opacity-60"
                >
                  {loading ? 'Logging in...' : <span style={{fontSize: 20}}>Login</span>}
                </button>
              </div>
            </form>
            <div style={{ textAlign: 'center', marginTop: 32, fontSize: 20, fontWeight: 600 }}>
              <span style={{ color: '#fff', fontSize: 22, fontWeight: 700, marginRight: 8 }}>Don't have an account?</span>
              <Link to="/signup" style={{ color: '#fff', fontWeight: 700, textDecoration: 'underline', marginLeft: 6, fontSize: 20 }}>
                Sign Up
              </Link>
            </div>
            {error && <p className="text-red-600 text-center mt-4">{error}</p>}
          </>
        )}
      </div>
    </div>
  );
};

export default Auth;
